export const languages = ["de", "en", "fr", "es", "ru", "zh-Hans"];
